import { bunja } from 'bunja';

import { subscribeFixedR230522TopicsBunja } from './internal/fixed-topics/subscribe';
import { weakR230522SocketBunja } from './internal/weak';

export type { V2SocketEvents } from './types';
export { weakR230522SocketBunja } from './internal/weak';
export { R230522Context } from './internal/context';

const subscribeR230522WebsocketBunja = bunja(() => {
  const { r230522Socket } = bunja.use(weakR230522SocketBunja);
  bunja.effect(() => {
    r230522Socket.connect();
    return () => r230522Socket.close();
  });
});
subscribeR230522WebsocketBunja.debugLabel = 'subscribeR230522WebsocketBunja';

export const r230522SocketBunja = bunja(() => {
  bunja.use(subscribeR230522WebsocketBunja);
  bunja.use(subscribeFixedR230522TopicsBunja);
  return bunja.use(weakR230522SocketBunja);
});
r230522SocketBunja.debugLabel = 'r230522SocketBunja';
